<template>
  <v-row class="align-center justify-center commercial-container">
    <v-card width="300" outlined>
      <v-card-text>
        <v-file-input
          v-model="file"
          accept=".csv, application/vnd.ms-excel"
          label="Select CSV File"
          outlined
        ></v-file-input>
        <v-btn
          :disabled="!file || !isPermittedTo('create')"
          :loading="isLoading"
          color="primary"
          block
          depressed
          @click="onClickUpload"
        >
          GIMME THAT DATA!
        </v-btn>
      </v-card-text>
    </v-card>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

import DataModification from '@/mixins/data-modification'
import PermissionsHandler from '@/mixins/permissions-handler'

import commercial from '@/services/commercial'

export default {
  name: 'CommercialUpload',
  mixins: [DataModification, PermissionsHandler],
  data: () => ({
    isLoading: false,
    file: null,
  }),
  computed: {
    ...mapGetters('general', ['hasPageErrors']),
  },
  methods: {
    async onClickUpload() {
      this.isLoading = true

      try {
        const data = new FormData()
        data.append('commercial-data', this.file)
        await commercial.uploadCommercialData(data)
        this.file = null
        this.$notify({
          type: 'success',
          text: 'File uploaded!',
        })
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Unable to upload file.',
        })
      }
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.commercial-container {
  height: 100vh;
}
</style>
